export default __webpack_public_path__ + "static/media/showcase.fa54daf1.png";